import { useSidebarLayout } from '~/layout/contexts/sidebar-layout/SidebarLayout';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { Button, ButtonProps } from '@/components/ui/button';
import { Pressable, View } from 'react-native';
import * as React from 'react';
import { forwardRef, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface SidebarItemProps extends ButtonProps {
  visual?: ReactNode;
  children?: ReactNode;
}

export const SidebarItem = forwardRef<
  React.ElementRef<typeof Pressable>,
  SidebarItemProps
>(
  (
    { children, visual, className, textClassName, ...props }: SidebarItemProps,
    ref,
  ) => {
    const { itemsDetailsVisibleState } = useSidebarLayout();
    const itemsStyle = useAnimatedStyle(() => ({
      opacity: itemsDetailsVisibleState.value,
    }));
    return (
      <Button
        variant="ghost"
        {...props}
        className={cn(
          'flex flex-row items-center justify-start gap-x-4 pl-2 pr-3 py-3 rounded-xl web:hover:bg-transparent active:bg-transparent web:transition-none',
          className,
        )}
        textClassName={cn(
          'font-inter-regular text-text-secondary web:transition-none',
          textClassName,
        )}
        ref={ref}
      >
        <View className="min-w-5 flex flex-row items-center justify-center">
          {visual}
        </View>
        <Animated.View style={[itemsStyle, { flex: 1 }]}>
          {children}
        </Animated.View>
      </Button>
    );
  },
);
SidebarItem.displayName = 'SidebarItem';
